import React, { useState } from 'react';
import { AlertTriangle, Bell, CheckCircle2, Clock3, Download, Eye, FileUp, Filter, History, Mail, Menu, Moon, MoreVertical, Search, ShieldCheck, Sun, XCircle } from 'lucide-react';
import './paysysShowcase.css';
const galleryRows = [['TXN-DEMO-001', 'RIA Money Transfer', 'OTC', 'USD 500.00', 'Failed', 'Duplicate Transaction'], ['TXN-DEMO-002', 'InstantCash', 'OTC', 'USD 750.00', 'In Progress', 'Balance inquiry timeout'], ['TXN-DEMO-003', 'MoneyGram', 'FT', 'USD 1,000.00', 'Manual Review', 'No HTTP Response Exception']];
export default function PaysysComponentGallery() {
  const [darkMode, setDarkMode] = useState(false);
  return <div className={`paysys-showcase ${darkMode ? 'dark' : ''}`} data-id="element-4129" data-mp="1m3vc0582zlln">
      <main className="paysys-gallery" data-id="element-4130" data-mp="1m6puvsbg4ycy">
        <header className="paysys-topbar" data-id="element-4131" data-mp="210uljymhtoir">
          <div data-id="element-4132" data-mp="20zjmgc3zt4xz">
            <img className="paysys-logo" src="/paysys-logo.png" alt="Paysys" data-id="element-4133" data-mp="1w2jf7xvepw5a" />
            <p className="paysys-eyebrow" data-id="element-4134" data-mp="1w0gf2l0jimmu">Component decision gallery</p>
            <h1 className="paysys-title" data-id="element-4135" data-mp="3exuxlkix990e">Reusable Backoffice UI System</h1>
            <p className="paysys-subtitle" data-id="element-4136" data-mp="3juutx3pyyxeb">
              Sample components for remittance operations, maker-checker queues, alerts,
              transaction exception handling, and module generation.
            </p>
          </div>
          <div className="paysys-actions" data-id="element-4137" data-mp="3sxvy2yv9yefc">
            <button className="paysys-button" onClick={() => setDarkMode(value => !value)} data-id="element-4138" data-mp="1q9pqsxm1ns5">
              {darkMode ? <Sun size={16} data-id="element-4139" data-mp="6ouo0mtaxxdy" /> : <Moon size={16} data-id="element-4140" data-mp="6obb5kiidz6s" />}
              {darkMode ? 'Light mode' : 'Dark mode'}
            </button>
            <a className="paysys-button primary" href="/paysys-design-preview" data-id="element-4141" data-mp="bgvzw7mk5m3g">
              Open screen preview
            </a>
          </div>
        </header>

        <section className="paysys-gallery-grid" data-id="element-4142" data-mp="kgizcnvq8htv">
          <article className="paysys-preview-panel" data-id="element-4143" data-mp="ki2jipki7d0x">
            <h2 className="paysys-section-title" data-id="element-4144" data-mp="pfceslukqiwo">Brand Tokens</h2>
            <div className="paysys-color-row" data-id="element-4145" data-mp="pdhv1av1gwu6">
              <div className="paysys-swatch" data-id="element-4146" data-mp="2lhz2ykwltkpa">
                <div className="paysys-swatch-color" style={{
                background: '#106898'
              }} data-id="element-4147" data-mp="2lgnysjz8yaxn" />
                <div data-id="element-4148" data-mp="2glh0xssns0gn">Paysys Blue<br data-id="element-4149" data-mp="2ghkuj1r3c8qq" />#106898</div>
              </div>
              <div className="paysys-swatch" data-id="element-4150" data-mp="2v9lll2b9um22">
                <div className="paysys-swatch-color" style={{
                background: '#F0C018'
              }} data-id="element-4151" data-mp="2vamub04tewgm" />
                <div data-id="element-4152" data-mp="2qgim6djtcidy">Paysys Gold<br data-id="element-4153" data-mp="2qg0iivutn1w0" />#F0C018</div>
              </div>
              <div className="paysys-swatch" data-id="element-4154" data-mp="347x92vgud3qa">
                <div className="paysys-swatch-color" style={{
                background: darkMode ? '#102536' : '#FFFFFF'
              }} data-id="element-4155" data-mp="34b2vu41zztiu" />
                <div data-id="element-4156" data-mp="3e75zxfgeu28f">Surface</div>
              </div>
              <div className="paysys-swatch" data-id="element-4157" data-mp="3e6w95pnjjr1o">
                <div className="paysys-swatch-color" style={{
                background: darkMode ? '#071622' : '#F5F8FB'
              }} data-id="element-4158" data-mp="398kyjcpf9cie" />
                <div data-id="element-4159" data-mp="1jsvb36ztf82n">Canvas</div>
              </div>
            </div>
          </article>

          <article className="paysys-preview-panel" data-id="element-4160" data-mp="1euk18w9isxkf">
            <h2 className="paysys-section-title" data-id="element-4161" data-mp="1ew4v0jo0gch8">Buttons and Actions</h2>
            <div className="paysys-actions" style={{
            justifyContent: 'flex-start'
          }} data-id="element-4162" data-mp="3qiowwi2k6owl">
              <button className="paysys-button primary" data-id="element-4163" data-mp="3vh04em5dsnbn"><CheckCircle2 size={16} data-id="element-4164" data-mp="3vfyrsd8pvsrt" /> Approve</button>
              <button className="paysys-button gold" data-id="element-4165" data-mp="3gsm52l76bgzu"><ShieldCheck size={16} data-id="element-4166" data-mp="3grkh5g52700p" /> Mark Priority</button>
              <button className="paysys-button" data-id="element-4167" data-mp="3lq5gldchlfo3"><Eye size={16} data-id="element-4168" data-mp="3lpcg2u44fmee" /> View Detail</button>
              <button className="paysys-button" data-id="element-4169" data-mp="37qmn9qoc48vu"><Download size={16} data-id="element-4170" data-mp="37qcxa33ai1q5" /> Export</button>
            </div>
          </article>

          <article className="paysys-preview-panel" data-id="element-4171" data-mp="3cra97xxphzj7">
            <h2 className="paysys-section-title" data-id="element-4172" data-mp="2xszsrvujy8qr">Status and Queue Chips</h2>
            <div className="paysys-actions" style={{
            justifyContent: 'flex-start'
          }} data-id="element-4173" data-mp="2xut43og41h53">
              <span className="paysys-chip green" data-id="element-4174" data-mp="32sl1uz3frxh7"><CheckCircle2 size={14} data-id="element-4175" data-mp="w1lmu9gxspgk" /> Completed</span>
              <span className="paysys-chip red" data-id="element-4176" data-mp="w24u8w8ynvgc"><XCircle size={14} data-id="element-4177" data-mp="vzsgkva8k793" /> Failed</span>
              <span className="paysys-chip orange" data-id="element-4178" data-mp="10zn7gyu0gwu5"><Clock3 size={14} data-id="element-4179" data-mp="10yltomlm1w8q" /> In Progress</span>
              <span className="paysys-chip gold" data-id="element-4180" data-mp="2x44fe8vktkp9"><AlertTriangle size={14} data-id="element-4181" data-mp="2x31npyqfje8a" /> Manual Review</span>
              <span className="paysys-chip" data-id="element-4182" data-mp="2t1zkz7xb0k1k"><Bell size={14} data-id="element-4183" data-mp="2t2r7lt8xb7fp" /> Alert Enabled</span>
            </div>
          </article>

          <article className="paysys-preview-panel" data-id="element-4184" data-mp="2o1v25b8xbd86">
            <h2 className="paysys-section-title" data-id="element-4185" data-mp="2j41wcjbj8l8f">Filters and Inputs</h2>
            <div className="paysys-form-grid" data-id="element-4186" data-mp="2j661f4l63qaa">
              <div className="paysys-field" data-id="element-4187" data-mp="2e58kevbw92ad">
                <label data-id="element-4188" data-mp="2e69yz9s4c6wu">Search</label>
                <input className="paysys-input" placeholder="Txn ID, MTO, reason" data-id="element-4189" data-mp="29eiengzk2xf5" />
              </div>
              <div className="paysys-field" data-id="element-4190" data-mp="25c5agx0gj7kh">
                <label data-id="element-4191" data-mp="25d6jkvxwxjzk">Status</label>
                <select className="paysys-input" defaultValue="failed" data-id="element-4192" data-mp="20dkb0zt14rx3">
                  <option value="failed" data-id="element-4193" data-mp="20fes2316jzvw">Failed</option>
                  <option value="progress" data-id="element-4194" data-mp="1vequszmcymt8">In Progress</option>
                  <option value="completed" data-id="element-4195" data-mp="1qfe8cfzefhr6">Completed</option>
                </select>
              </div>
              <div className="paysys-field" data-id="element-4196" data-mp="1gbhbz7r7wx3i">
                <label data-id="element-4197" data-mp="1gao0xul87lfk">Created From</label>
                <input className="paysys-input" type="date" data-id="element-4198" data-mp="1gdtp97m16ja8" />
              </div>
              <div className="paysys-field" data-id="element-4199" data-mp="1l8pnwqlrw4wb">
                <label data-id="element-4200" data-mp="1q93wqav77ive">Reason</label>
                <input className="paysys-input" placeholder="Duplicate Transaction" data-id="element-4201" data-mp="1qa6ik4dnyv4g" />
              </div>
            </div>
          </article>
        </section>

        <section className="paysys-gallery-grid" data-id="element-4202" data-mp="xlhqeuul604u">
          <article className="paysys-preview-panel" style={{
          gridColumn: '1 / -1'
        }} data-id="element-4203" data-mp="xmsukvry19wh">
            <div className="paysys-card-header" data-id="element-4204" data-mp="12kkkjk912ly1">
              <h2 className="paysys-section-title" data-id="element-4205" data-mp="17jfd3dwsrovc">Operational Data Table</h2>
              <div className="paysys-actions" data-id="element-4206" data-mp="17hazg493jbhv">
                <button className="paysys-button" data-id="element-4207" data-mp="1caxf85ak3vhw"><Filter size={16} data-id="element-4208" data-mp="1cb6wn4hjcubz" /> Filters</button>
                <button className="paysys-button" data-id="element-4209" data-mp="ev9t4tdki3wk"><Search size={16} data-id="element-4210" data-mp="etyoysg7mu4x" /> Search</button>
                <button className="paysys-button" data-id="element-4211" data-mp="jtb8p4bsbl3a"><MoreVertical size={16} data-id="element-4212" data-mp="js9z74af36no" /> Columns</button>
              </div>
            </div>
            <div className="paysys-table-wrap" data-id="element-4213" data-mp="brtzk2sdjtq3">
              <table className="paysys-table" data-id="element-4214" data-mp="bqiw642ucnzi">
                <thead data-id="element-4215" data-mp="6sr51ca0t5wd">
                  <tr data-id="element-4216" data-mp="6timzkap3546">
                    <th data-id="element-4217" data-mp="6ry10j2g4uhx">Txn ID</th>
                    <th data-id="element-4218" data-mp="liyckwyhp4ia">MTO</th>
                    <th data-id="element-4219" data-mp="li5eslhidpca">Type</th>
                    <th data-id="element-4220" data-mp="gjlpqc7mbxfp">Amount</th>
                    <th data-id="element-4221" data-mp="gjby6k6xdi7w">Lifecycle</th>
                    <th data-id="element-4222" data-mp="gkdjrilkhn3v">Reason</th>
                    <th data-id="element-4223" data-mp="3oz5dwwtfmpnw">Actions</th>
                  </tr>
                </thead>
                <tbody data-id="element-4224" data-mp="3p18da7gh5v5a">
                  {galleryRows.map(row => <tr key={row[0]} data-id="element-4225" data-mp="3k1vjt3v3lptq">
                      <td data-id="element-4226" data-mp="2s72tualbc3d"><strong data-id="element-4227" data-mp="2rxf6dd0ph0u">{row[0]}</strong></td>
                      <td data-id="element-4228" data-mp="2tryxocjz33c">{row[1]}</td>
                      <td data-id="element-4229" data-mp="3tyi2blzyc4sl"><span className="paysys-chip gold" data-id="element-4230" data-mp="3tyi3vqflocup">{row[2]}</span></td>
                      <td data-id="element-4231" data-mp="3u0l1owmzva9z"><strong data-id="element-4232" data-mp="3u0urok81hhfo">{row[3]}</strong></td>
                      <td data-id="element-4233" data-mp="1e6azx9ch5gcn"><span className={`paysys-chip ${row[4] === 'Failed' ? 'red' : row[4] === 'Manual Review' ? 'gold' : 'orange'}`} data-id="element-4234" data-mp="1e6av8w1j4s6b">{row[4]}</span></td>
                      <td data-id="element-4235" data-mp="1grs4j7z8lyg3">{row[5]}</td>
                      <td data-id="element-4236" data-mp="1gqqsp1aed7xb"><MoreVertical size={18} data-id="element-4237" data-mp="1gqqr4wur0zv7" /></td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </article>

          <article className="paysys-preview-panel" data-id="element-4238" data-mp="17rlszrn3n8jk">
            <h2 className="paysys-section-title" data-id="element-4239" data-mp="17t6qnq4pn7ln">Form Drawer Pattern</h2>
            <div className="paysys-form-grid" data-id="element-4240" data-mp="1btgx13wf0011">
              <div className="paysys-field" data-id="element-4241" data-mp="1zi9td1gy89w6">
                <label data-id="element-4242" data-mp="1zjkxx3i7xloc">Alert Event</label>
                <input className="paysys-input" value="Transaction Failed" readOnly data-id="element-4243" data-mp="1zkmbpfqmcm9r" />
              </div>
              <div className="paysys-field" data-id="element-4244" data-mp="1qpy5nnd7z0jw">
                <label data-id="element-4245" data-mp="1qowwjofrko4t">Channel</label>
                <select className="paysys-input" defaultValue="email" data-id="element-4246" data-mp="1qnvh77rptfha">
                  <option value="email" data-id="element-4247" data-mp="1uq8k7of2uzad">Email</option>
                  <option value="sms" data-id="element-4248" data-mp="2ihe0g4oxjtl7">SMS</option>
                </select>
              </div>
              <div className="paysys-field" style={{
              gridColumn: '1 / -1'
            }} data-id="element-4249" data-mp="2n7ui60zsa1dd">
                <label data-id="element-4250" data-mp="2n9ypyu0szkix">Template</label>
                <textarea className="paysys-input" defaultValue="Dear user, transaction {{txnId}} requires review due to {{reason}}." data-id="element-4251" data-mp="1yhq1fn5ajew3" />
              </div>
            </div>
          </article>

          <article className="paysys-preview-panel" data-id="element-4252" data-mp="1oqvh4oblupda">
            <h2 className="paysys-section-title" data-id="element-4253" data-mp="1oroewzsl64ja">Detail Drawer and Timeline</h2>
            <div className="paysys-timeline" data-id="element-4254" data-mp="1jtmuobjfbz68">
              <div className="paysys-timeline-row" data-id="element-4255" data-mp="2hg2cxfjod0uu"><span data-id="element-4256" data-mp="2hf129c6kmgdn"><CheckCircle2 size={15} data-id="element-4257" data-mp="2hf0zx5j3m4ah" /> Received from MTO</span><strong data-id="element-4258" data-mp="2hdpwx7xh90kf">10:24 AM</strong></div>
              <div className="paysys-timeline-row" data-id="element-4259" data-mp="2ci0yj7x71ppp"><span data-id="element-4260" data-mp="2cewjtgm3rbks"><AlertTriangle size={15} data-id="element-4261" data-mp="2cewnprp83vq2" /> Failed validation</span><strong data-id="element-4262" data-mp="27gv2b04brkbf">10:25 AM</strong></div>
              <div className="paysys-timeline-row" data-id="element-4263" data-mp="27jzdihg7jgbl"><span data-id="element-4264" data-mp="22jbcd2y9lj3n"><History size={15} data-id="element-4265" data-mp="22jbg9e1dy38x" /> Sent for checker review</span><strong data-id="element-4266" data-mp="22kw82vwbf833">10:31 AM</strong></div>
            </div>
          </article>

          <article className="paysys-preview-panel" data-id="element-4267" data-mp="w4apdmr7wb97">
            <h2 className="paysys-section-title" data-id="element-4268" data-mp="r3wjobd39dec">Upload Workflow</h2>
            <div className="paysys-empty" data-id="element-4269" data-mp="r5r0pel8old5">
              <FileUp size={34} data-id="element-4270" data-mp="32rrlfyhyodfj" />
              <h3 data-id="element-4271" data-mp="32skrsyd0d0x5">Drop reversal file here</h3>
              <p className="paysys-subtitle" style={{
              margin: '0 auto 14px'
            }} data-id="element-4272" data-mp="37ptcb5lmph1k">CSV and XLSX files up to 10 MB.</p>
              <button className="paysys-button primary" data-id="element-4273" data-mp="3cow8e0jmscxe"><FileUp size={16} data-id="element-4274" data-mp="3cnuvrrmyvidk" /> Upload file</button>
            </div>
          </article>

          <article className="paysys-preview-panel" data-id="element-4275" data-mp="3hhgz2t78q9wp">
            <h2 className="paysys-section-title" data-id="element-4276" data-mp="3mfiijf8kwb8p">Notifications and Loading</h2>
            <div className="paysys-toast" data-id="element-4277" data-mp="3qgkjc0i58vcs"><Mail size={15} data-id="element-4278" data-mp="3qfszto1tmo2v" /> Alert template saved successfully.</div>
            <div className="paysys-skeleton" style={{
            width: '85%'
          }} data-id="element-4279" data-mp="3vfnpxpdrv9mv" />
            <div className="paysys-skeleton" style={{
            width: '70%'
          }} data-id="element-4280" data-mp="3vggm5wf3ugqr" />
            <div className="paysys-skeleton" style={{
            width: '92%'
          }} data-id="element-4281" data-mp="48b42x1y280m" />
          </article>

          <article className="paysys-preview-panel" style={{
          gridColumn: '1 / -1'
        }} data-id="element-4282" data-mp="212o59hujbp8q">
            <h2 className="paysys-section-title" data-id="element-4283" data-mp="25zxq0k6zbcq8">Application Shell Sample</h2>
            <div className="paysys-status-row" data-id="element-4284" data-mp="3n76xsmyl3psb">
              <span className="paysys-actions" style={{
              justifyContent: 'flex-start'
            }} data-id="element-4285" data-mp="3n8i6n16vznqa">
                <Menu size={18} data-id="element-4286" data-mp="3s72z2efwd346" />
                <img src="/paysys-logo.png" alt="Paysys" style={{
                width: 100
              }} data-id="element-4287" data-mp="3s8e3mgh62ewc" />
                <span className="paysys-chip" data-id="element-4288" data-mp="yfg2554przs">Dashboard / Failed Transactions</span>
              </span>
              <span className="paysys-actions" data-id="element-4289" data-mp="52wvjs4ghj4r">
                <span className="paysys-chip green" data-id="element-4290" data-mp="a16ri4y08nrf">Admin Maker</span>
                <span className="paysys-avatar" style={{
                width: 34,
                height: 34,
                borderRadius: 10
              }} data-id="element-4291" data-mp="9yub3w7walgh">A</span>
              </span>
            </div>
          </article>
        </section>
      </main>
    </div>;
}